import React from 'react';
import { Typography, Collapse } from 'antd';
import { PlusCircleOutlined, MinusCircleOutlined } from '@ant-design/icons';
import SEO from '../components/SEO';

const { Title, Text, Paragraph } = Typography;
const { Panel } = Collapse;

const FAQ = () => {
  const faqs = [
    {
      key: '1',
      question: 'Why should I compress my images?',
      answer: 'Compresing images reduces the file size, making them faster to load on websites. This improves page speed, boosts SEO rankings, and saves bandwidth for your website visitors.'
    },
    {
      key: '2',
      question: 'Does image compression reduce quality?',
      answer: 'Our COMPRESSAI Engine utilizes lossless and near-lossless optimization algorithms, meaning the final image looks virtually identical to the original but with a significantly smaller file size.'
    },
    {
      key: '3',
      question: 'What is the maximum file size for uploads?',
      answer: "Currently, you can upload payloads in .ZIP format with a total size of up to 200MB. This allows for bulk processing of hundreds of images in a single workflow."
    },
    {
      key: '4',
      question: 'Is my data secure with COMPRESS AI?',
      answer: 'Absolutely. We use enterprise-grade encryption for all data handling. Your images are only used for the compression process, and they are not stored permanently on our servers.'
    },
    {
      key: '5',
      question: 'What are the main benefits of using this tool?',
      answer: 'The key benefits include ultra-fast processing speeds, bulk ZIP archive support, real-time telemetry on bandwidth reduction (achieving an average of 81%+), and a premium user interface designed for high-performance workflows.'
    }
  ];

  return (
    <div className="w-full max-w-4xl mx-auto px-6 py-12 md:py-24 animate-fade-in-up">
      <SEO 
        title="Frequently Asked Questions - FAQ"
        description="Find answers to common questions about image optimization, file size limits, data security, and the benefits of using COMPRESS AI."
        keywords={['image compression faq', 'is image compression safe', 'maximum file size for images', 'why compress images']}
      />
      
      <div className="text-center mb-16">
        <Title level={1} className="!text-white !text-5xl !font-bold tracking-tight mb-4 text-glow">
          COMPRESS AI <span className="text-purple-400">FAQ</span>
        </Title>
        <Text className="text-purple-200/60 text-lg font-medium tracking-wide">
          Everything you need to know about our image optimization platform.
        </Text>
      </div>

      <Collapse
        bordered={false}
        expandIcon={({ isActive }) => 
          isActive ? 
          <MinusCircleOutlined className="text-purple-400 text-xl" /> : 
          <PlusCircleOutlined className="text-purple-400 text-xl" />
        }
        className="glass-panel-dark border-white/5 rounded-3xl overflow-hidden p-6"
        accordion
      >
        {faqs.map(faq => (
          <Panel 
            header={<Title level={4} className="!text-white !m-0 pr-4 hover:text-purple-400 !transition-colors !duration-300">{faq.question}</Title>} 
            key={faq.key}
            className="border-b border-white/5 last:border-0 !bg-transparent py-4 text-glow-hover"
          >
            <Paragraph className="text-slate-400 text-lg leading-relaxed pt-2 px-1">
              {faq.answer}
            </Paragraph>
          </Panel>
        ))}
      </Collapse>
      
    </div>
  );
};

export default FAQ;
